import type { SuccessResponse } from '@/api/types';
import route from '@router/route';
import { backend } from '.';

export function report404Page(url: string, ref = '') {
    return backend
        .post<SuccessResponse>(route('report.404'), {
            url,
            ref,
        })
        .then((response) => response.data.success);
}
